import cloneDeep from 'lodash/cloneDeep'
import { getDateConfig } from '@/utils/dateConfig'
import { moneyFormatRules } from '@/utils/moneyFormatRules'
import { globalVariable } from '@/utils/exportVariable'

export const defaultUsers = () => {
  const ordinaryUsers = globalVariable.i18n.t('member').membership_level1
  return ordinaryUsers || '普通用户'
}

// 返回当前会员等级
export const currentLevel = (levelCode = 0) => {
  if (levelCode !== 0 && levelCode <= 6) {
    return `VIP${levelCode}`
  }

  if (levelCode !== 0 && levelCode > 6) {
    return `SVIP${levelCode - 6}`
  }

  return defaultUsers()
}

// 返回当前会员等级 - 简写
export const currentLevelShort = (levelCode = 0) => {
  if (levelCode !== 0 && levelCode <= 6) {
    return `vip${levelCode}`
  }

  if (levelCode !== 0 && levelCode > 6) {
    return `svip${levelCode - 6}`
  }

  return ''
}

// 返回【优惠券】和【会员配置】的关系队列
export const filtrateCouponIds = (_coupons, _couponList) => {
  const result = _coupons.reduce((previousValue, currentValue) => {
    const data = {}
    const item = _couponList.filter((_item) =>
      currentValue.couponIds.find((__item) => +__item === _item.id)
    )
    if (item && item.length) {
      data.levelCode = currentLevel(currentValue.levelCode)
      data.preLevelCode = currentLevel(currentValue.levelCode - 1)
      data.nextLevelCode = currentLevel(currentValue.levelCode + 1)
      data._levelCode = currentValue.levelCode
      data._preLevelCode = currentValue.levelCode - 1
      data._nextLevelCode = currentValue.levelCode + 1
      data.mapids = item
      previousValue.push(data)
    }

    return previousValue
  }, [])

  return result
}

/**
 * @description: 返回全部会员等级List and 开始、结束的消费值
 * @param { Object[Array ]} userConfig 默认的配置数组
 * @param { Object[boolean]} isNotUser 是否展示【普通用户】字段
 * @return { Object }
 */
export const filterLevelList = ({ userConfig = [], isNotUser = false }) => {
  // 不改变原数组
  const userConfigList = cloneDeep(userConfig)

  if (!userConfigList.length) return []

  const result = userConfigList.map((item) => {
    const { levelCode, startSpendingExp, endSpendingExp } = item
    let value = ''

    const level =
      levelCode === 0
        ? defaultUsers()
        : levelCode <= 6
        ? `VIP${levelCode}`
        : `SVIP${levelCode - 6}`

    if (levelCode === 11) {
      value = `${startSpendingExp}以上`
    } else {
      value = `${startSpendingExp}-${endSpendingExp}`
    }

    return {
      level,
      value,
      levelCode,
      startSpendingExp,
      // endSpendingExp:
      //   levelCode === 11 ? `${startSpendingExp}以上` : startSpendingExp,
      endSpendingExp,
    }
  })

  // remove
  if (isNotUser) {
    result.shift()
  }

  return result
}

// 过滤返回优惠券的时间
export const couponExpirationTime = (that, data) => {
  const { timeType, timeEnd, timeBegin, timeEffective } = data
  const currentTime = new Date().getTime() / 1000
  const time_format_1 = getDateConfig().year_mins
  const time_format_2 = getDateConfig().expires_at

  let time = ''
  if (timeType === 1) {
    time = `${timeEffective}`
  } else if (timeType === 2) {
    time =
      currentTime < Number(timeBegin)
        ? `${that.$options.filters['formatTime'](
            timeBegin,
            time_format_1
          )}-${that.$options.filters['formatTime'](timeEnd, time_format_1)}`
        : `${that.$options.filters['formatTime'](timeEnd, time_format_2)}`
  }
  return {
    timeType,
    time,
  }
}
export const formatCurrency = (currency, amount) => {
  if (!moneyFormatRules.SymbolInAfter) {
    return currency + amount
  } else {
    return amount + currency
  }
}

/**
 * 超越xx.xx%用户
 * 注: 比率根据会员等级写死
 * @param {*} levelCode 会员等级
 * @returns 百分比
 */
export function surpassPercent(levelCode) {
  const level = currentLevelShort(levelCode)
  const percents = new Map([
    ['vip1', '5.59%'],
    ['vip2', '37.40%'],
    ['vip3', '68.84%'],
    ['vip4', '78.78%'],
    ['vip5', '88.78%'],
    ['vip6', '97.01%'],
    ['svip1', '99.05%'],
    ['svip2', '99.65%'],
    ['svip3', '99.95%'],
    ['svip4', '99.98%'],
    ['svip5', '99.99%'],
  ])
  return percents.get(level)
}
